import { render, staticRenderFns } from "./CompletedSkill.vue?vue&type=template&id=5b231537&scoped=true&"
import script from "./CompletedSkill.vue?vue&type=script&lang=js&"
export * from "./CompletedSkill.vue?vue&type=script&lang=js&"
import style0 from "./CompletedSkill.vue?vue&type=style&index=0&id=5b231537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b231537",
  null
  
)

export default component.exports